import { ReactNode } from "react";

import { Ds } from "@accurx/design";
import styled from "styled-components";

type MoreInformationTooltipLinkProps = {
    children: ReactNode;
    text: string;
    id: string;
};

const MoreInformationTooltipLink = ({
    id,
    text,
    children,
}: MoreInformationTooltipLinkProps) => {
    return (
        <>
            <Ds.Tooltip>
                <Ds.Tooltip.Trigger>
                    <Ds.Flex alignItems="center" id={id} className="ml-2">
                        <Ds.Icon color="zinc" name="Info" size="small" />
                        <Ds.Text
                            color="zinc"
                            as="span"
                            className="text-decoration-underline"
                        >
                            {text}
                        </Ds.Text>
                    </Ds.Flex>
                </Ds.Tooltip.Trigger>
                <Ds.Tooltip.Content side="bottom">
                    <StyledContent>{children}</StyledContent>
                </Ds.Tooltip.Content>
            </Ds.Tooltip>
        </>
    );
};

export default MoreInformationTooltipLink;

export const StyledContent = styled.div`
    width: 200px;
`;
